export const FIXED_CATEGORIES = ['주거비', '공과금', '교통비', '통신비'];

export const EXPENSE_RATIO_THRESHOLDS = {
  good: { max: 70, label: '양호', colorClass: 'insights-status--success' },
  warning: { max: 90, label: '주의', colorClass: 'insights-status--warning' },
  danger: { max: Infinity, label: '위험', colorClass: 'insights-status--error' },
};

export const SAVINGS_RATE_THRESHOLDS = {
  excellent: { min: 20, label: '우수', colorClass: 'insights-status--success' },
  normal: { min: 10, label: '보통', colorClass: 'insights-status--warning' },
  needsImprovement: {
    min: -Infinity,
    label: '개선필요',
    colorClass: 'insights-status--error',
  },
};

export const INCOME_STABILITY_THRESHOLDS = {
  stable: { min: 80, label: '안정', colorClass: 'insights-status--success' },
  normal: { min: 60, label: '보통', colorClass: 'insights-status--warning' },
  unstable: {
    min: -Infinity,
    label: '불안정',
    colorClass: 'insights-status--error',
  },
};

export const MIN_TRANSACTIONS_FOR_INSIGHTS = 5;
export const MIN_MONTHS_FOR_STABILITY = 2;
export const TOP_CATEGORIES_COUNT = 5;
